import { FC, useState } from 'react';

import { useApplication } from '@eneco/common/application';
import { useRouter } from '@eneco/next';
import { Box, Button, Grid, Heading, PageGrid, Text } from '@eneco/sparky';
import { ForgotEmailConfirmedRendering } from '@sitecore/types/ForgotEmailConfirmed';
import { signIn } from 'next-auth/react';

import CenteredCardLayout from '../../../../components/CenteredCardLayout';
import DataErrorNotification from '../../../../components/DataErrorNotification';

interface RedirectContext {
  type: string;
  additionalProperties: Record<string, string>;
}

const ForgotEmailConfirmed: FC<ForgotEmailConfirmedRendering> = ({ fields }) => {
  const { searchParams } = useApplication();
  const [isLoading, setLoading] = useState(false);
  const { locale } = useRouter();

  const redirectContextBase64 = searchParams.get('redirectContext');

  if (!redirectContextBase64) {
    return (
      <Box paddingY="10">
        <PageGrid>
          <Grid.Item gridColumn={{ initial: '1/-1', md: '4/-2', lg: '5/9' }} gridRowStart="1">
            <DataErrorNotification />
          </Grid.Item>
        </PageGrid>
      </Box>
    );
  }

  const redirectContextWrapper = atob(redirectContextBase64);
  const redirectContext: RedirectContext = JSON.parse(redirectContextWrapper);
  const displayName = redirectContext.additionalProperties?.displayName;

  const login = async () => {
    setLoading(true);
    await signIn(
      'okta',
      { callbackUrl: `/${locale}/my-eneco/dashboard` },
      { login_hint: redirectContext.additionalProperties.email },
    );
  };

  return (
    <CenteredCardLayout>
      <Heading size="S" as="h2">
        {fields.title.value}
      </Heading>
      <Heading size="XS" as="h3">
        <Text>
          {fields.salutationLabel.value}
          {displayName ? ` ${displayName}` : ''},
        </Text>
      </Heading>
      <Text>{fields.content.value}</Text>
      <Text weight="bold">{fields.loginHintContent.value}</Text>
      <Text>{fields.itsMeReminderContent.value}</Text>
      <Button action="primary" size="regular" tone="onLight" type="submit" onClick={login} isLoading={isLoading}>
        {fields.loginButtonText.value}
      </Button>
    </CenteredCardLayout>
  );
};

export default ForgotEmailConfirmed;
